// @flow
import type { Address } from 'types'
import kebabCase from 'lodash/kebabCase'
import compact from 'lodash/compact'

type School = {
  address: Address | null,
  slug: string,
}

export default function schoolVanityUrl(school: School): string {
  const url = `/${school.slug}`
  const address = school.address

  if (!address) return url

  const parts = compact([kebabCase(address.state || ''), kebabCase(address.city || '')])

  if (parts.length !== 2) return url
  return `/${parts[0]}/${parts[1]}/${school.slug}`
}
